import * as React from "react";

const NavDivider: React.FC<{}> = () => {
  return (
    <li className="navbar-divider"/>
  );
};

export default NavDivider;
